import React from 'react';
import '../assets/css/loading.css';
import logo from '../assets/img/logos/unik-logo.png';

const LoadingKeycloak = () => {
  return (
    <div className="loading-page">
      <img src={logo} alt="Loading" />
    </div>
  );
}

export default LoadingKeycloak;
